const useCustomWidthStyle = ({
  containerData,
  isMobile,
  width
}) => {
  return containerData?.width?.size === "ORIGINAL" || isMobile && (Number(containerData?.width?.custom) || 0) > 150 ? { width: width ?? "0px", maxWidth: "100%" } : {};
};
export {
  useCustomWidthStyle
};
//# sourceMappingURL=use-custom-width-style.js.map
